import { render } from "./add-methods-dialog.vue?vue&type=template&id=5102f483&ts=true"
import script from "./add-methods-dialog.ts?vue&type=script&lang=ts"
export * from "./add-methods-dialog.ts?vue&type=script&lang=ts"

import "./add-methods-dialog.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__